import Modal from './Modal';
import AvisoModal from './AvisoModal';
import styles from './ConfirmDeleteModal.module.css';

// Modal de confirmación de borrado compartido — mismo estilo (ícono en
// círculo + texto) que ya usaban por separado Buildings.jsx y Units.jsx,
// ahora en un solo lugar para no repetir el mismo bloque de JSX en cada
// página que borra algo.
// `error`: motivo por el que NO se pudo borrar (el mensaje del servidor). Se muestra DENTRO del modal, fijo arriba (AvisoModal), porque la
// alerta de la página queda tapada por el modal; el modal sigue abierto para que se lea el motivo y se pueda cancelar o reintentar.
export default function ConfirmDeleteModal({ title, children, onClose, onConfirm, deleting, error, maxWidth = 420 }) {
  return (
    <Modal onClose={() => !deleting && onClose()} maxWidth={maxWidth}>
      <div className="modal-header">
        <h3><i className={`fas fa-trash ${styles.iconoTitulo}`} />{title}</h3>
        <button className="btn-close" onClick={onClose} disabled={deleting}>✕</button>
      </div>
      <div className="modal-body">
        {error && <AvisoModal>{error}</AvisoModal>}
        <div className={styles.caja}>
          <div className={styles.circulo}>
            <i className={`fas fa-exclamation-triangle ${styles.circuloGlifo}`} />
          </div>
          <div>{children}</div>
        </div>
      </div>
      <div className="modal-footer">
        <button className="btn btn-secondary" onClick={onClose} disabled={deleting}>Cancelar</button>
        <button className="btn btn-danger" onClick={onConfirm} disabled={deleting}>
          {deleting
            ? <><div className={`spinner ${styles.spinner}`} /> Eliminando...</>
            : <><i className="fas fa-trash" /> Sí, eliminar</>}
        </button>
      </div>
    </Modal>
  );
}
